import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Swal from 'sweetalert2';
import DataTable from '../components/DataTable';

const ListarEnteVsJefe = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [asociaciones, setAsociaciones] = useState([]);

  const getData = useCallback(async () => {
    try {
      const { data } = await axios.get(`/api/asociarjefes/listbyente/${id}`);

      const asociacionesConFunciones = data.asociaciones.map(asociacion => {
        const jefe = asociacion.jefeObjectId || {};
        const ente = asociacion.enteObjectId || {};

        const nombreCompleto = [
          jefe.nombre1Jefe,
          jefe.nombre2Jefe,
          jefe.apellido1Jefe,
          jefe.apellido2Jefe
        ].filter(Boolean).join(' ') || 'Sin información';

        return {
          ...asociacion,
          nombreCompleto,
          documentoJefe: jefe.documentoJefe || 'N/A',
          nombreEnteConformador: ente.nombreEnteconformador || 'N/A',
          fechaAsignacion: asociacion.fechaAsignacion
            ? new Date(asociacion.fechaAsignacion).toLocaleDateString('es-CO')
            : '',
          funciones: (
            <div className="d-flex gap-2">

              <button
                className="btn btn-warning"
                style={{ width: "30px", height: "30px", padding: "0" }}
                onClick={() => navigate(`/enteconformador/asociar/jefeinmediato/editar/${asociacion._id}`)}
              >
                <i className="fa-solid fa-pen-to-square"></i>
              </button>

              <button
                className="btn btn-danger"
                style={{ width: "30px", height: "30px", padding: "0" }}
                onClick={() => deleteAsociacion(asociacion._id)}
              >
                <i className="fa-solid fa-trash"></i>
              </button>
            </div>
          )
        };
      });

      setAsociaciones(asociacionesConFunciones);
    } catch (error) {
      console.error('Error al cargar los datos de asociaciones:', error.message);
    }
    // eslint-disable-next-line 
  }, [id]);



  // Función para eliminar una asociación
  const deleteAsociacion = async (id) => {
    try {
      const result = await Swal.fire({
        title: '¿Está seguro?',
        text: '¡No podrá revertir este proceso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar!',
      });

      if (result.isConfirmed) {
        const { data } = await axios.delete(`/api/asociarjefes/delete/${id}`);
        await getData(); // Refrescar los datos
        Swal.fire({
          icon: 'success',
          title: data.message || 'Asociación eliminada con éxito',
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error('Error al eliminar la asociación:', error.message);
      Swal.fire('Error', 'No se pudo eliminar la asociación. Por favor, inténtelo de nuevo.', 'error');
    }
  };

  // Cargar datos al montar el componente
  useEffect(() => {
    getData();
  }, [getData]);

  // Columnas de la tabla
  const columns = React.useMemo(() => [
    { Header: 'Jefe', accessor: 'nombreCompleto' },
    { Header: 'EnteConformador', accessor: 'nombreEnteConformador' },
    {
      Header: 'Fecha Asignación',
      accessor: 'fechaAsignacion',
      Cell: ({ value }) => (value ? value.slice(0, 10) : ''),
    },
    { Header: 'Estado', accessor: 'estadoAsignacion' },
    { accessor: 'funciones' },

  ], []);

  return (
    <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-5">
      <h1>Lista de Asignaciones</h1>
      {Array.isArray(asociaciones) && asociaciones.length > 0 ? (
        <DataTable columns={columns} data={asociaciones} />
      ) : (
        <p>Cargando asociaciones...</p>
      )}
    </div>
  );
};

export default ListarEnteVsJefe
  ;
